package com.sweetlime.bingeamigo.api

import com.sweetlime.bingeamigo.error.TmdbRateLimitException
import com.sweetlime.bingeamigo.model.Episode
import com.sweetlime.bingeamigo.model.MovieDetail
import com.sweetlime.bingeamigo.model.MoviesResponse
import com.sweetlime.bingeamigo.model.SeasonDetail
import com.sweetlime.bingeamigo.model.TvShowDetail
import com.sweetlime.bingeamigo.model.TvShowResponse
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.FirebaseFunctionsException
import dev.gitlive.firebase.functions.FunctionsExceptionCode
import dev.gitlive.firebase.functions.code
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.Serializable

class TmdbApi {

    @Serializable
    private data class ProxyRequest(
        val endpoint: String,
        val params: Map<String, String> = emptyMap()
    )

    private suspend inline fun <reified T> callProxy(
        endpoint: String,
        params: Map<String, String> = emptyMap()
    ): T {
        try {
            // Reified invoke avoids gitlive 2.1.0 JS double-encoding bug (strategy overload re-encodes native JS obj → Any serializer not found).
            return Firebase.functions
                .httpsCallable("tmdbProxy")
                .invoke(ProxyRequest(endpoint, params))
                .data()
        } catch (e: FirebaseFunctionsException) {
            if (e.code == FunctionsExceptionCode.RESOURCE_EXHAUSTED) {
                throw TmdbRateLimitException()
            }
            throw e
        }
    }

    suspend fun getPopularMovies(): MoviesResponse =
        callProxy("movie_popular")

    suspend fun getPopularTvShows(): TvShowResponse =
        callProxy("tv_popular")

    suspend fun searchMovies(query: String): MoviesResponse =
        callProxy("search_movie", mapOf("query" to query))

    suspend fun searchTvShows(query: String): TvShowResponse =
        callProxy("search_tv", mapOf("query" to query))

    suspend fun getMovieDetail(movieId: Int): MovieDetail =
        callProxy("movie_detail", mapOf("id" to movieId.toString()))

    suspend fun getTvShowDetail(tvShowId: Int): TvShowDetail =
        callProxy("tv_detail", mapOf("id" to tvShowId.toString()))

    suspend fun getSeasonDetail(tvShowId: Int, seasonNumber: Int): SeasonDetail =
        callProxy(
            "season_detail",
            mapOf("id" to tvShowId.toString(), "seasonNumber" to seasonNumber.toString())
        )

    suspend fun getEpisodeDetail(tvShowId: Int, seasonNumber: Int, episodeNumber: Int): Episode =
        callProxy(
            "episode_detail",
            mapOf(
                "id" to tvShowId.toString(),
                "seasonNumber" to seasonNumber.toString(),
                "episodeNumber" to episodeNumber.toString()
            )
        )
}